// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"612":"54fe6c86","869":"c6d45473"}[chunkId] + ".chunk.js";
};